import LayoutCentered from "./LayoutCentered";
import { StackedLogo } from "./Logos";
import Spacer from "./Spacer";

export default function AuthLayout({ children, heading, message }) {
  return (
    <LayoutCentered>
      <div className="w-full max-w-md px-3">
        <div className="bg-white rounded-lg p-8">
          <StackedLogo />
          <Spacer />
          {heading && (
            <>
              <h1 className="text-xl font-bold text-center text-gray-600">
                {heading}
              </h1>
              <Spacer size="large" />
            </>
          )}
          {message && (
            <>
              <p className="text-center">{message}</p>
              <Spacer size="medium" />
            </>
          )}
          {children}
        </div>
      </div>
    </LayoutCentered>
  );
}
